import { Dispatch, SetStateAction, createContext } from 'react';
import TreeNode from '@modules/ui/shared/interfaces/TreeNode';
import HeadingItem from '@modules/utilities/interfaces/HeadingItem';
import { SingleSelectTreeViewState } from './components/Tree';

export type ExpandableInfo = { nodeId: string; expanded: boolean };
export type TreeNodeWithHeading = TreeNode & {
  heading?: HeadingItem;
  children: TreeNodeWithHeading[];
};

export type AppMainConfigContext = {
  rightNav: SingleSelectTreeViewState & {
    treeNode: TreeNodeWithHeading | null;
    nodeIds: string[];
    expandableInfos: ExpandableInfo[];
    setExpanded: (nodeIds: string[]) => void;
    isEmpty: boolean;
    setSelected: Dispatch<SetStateAction<string>>;
  };
  mainMaxWidth: number;
  setAccordionExpanded: (accordionId: string, value: boolean) => void;
  pageTitle: string;
};

const AppMainConfigContext = createContext<AppMainConfigContext>({
  rightNav: {
    treeNode: null,
    nodeIds: [],
    expandableInfos: [],
    expanded: [],
    isEmpty: true,
    setExpanded: () => {
      throw Error('not implemented');
    },
    selected: '',
    setSelected: () => {
      throw Error('not implemented');
    },
  },
  mainMaxWidth: 912,
  setAccordionExpanded: () => {
    throw Error('not implemented');
  },
  pageTitle: '',
});
AppMainConfigContext.displayName = 'AppRightNavContent';

export default AppMainConfigContext;
